import React from "react";

const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
      <span>© 2025 Technoserve it solutions. All rights reserved.</span>
      <span className="footer-links">
        <a
          href="https://www.linkedin.com/company/technoserve-it-solutions/?lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_companies%3BEnMtCtFYSb%2BuKZdVw3z3qw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>{" "}
        |
        <a
          href="https://www.instagram.com/technoservitsolutions/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Instagram
        </a>{" "}
        {/* |
        <a
          href="https://facebook.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Facebook
        </a> */}
      </span>
    </div>
  </footer>
);

export default Footer;
